export default __webpack_public_path__ + "static/media/017-sari.91f6e228.svg";